<template>
  <lab-view v-if="route === 'lab'"></lab-view>
</template>
<script>
import LabView from "@/views/LabView.vue";

export default {
  name: "RouterComponent",
  components: {
    LabView,
  },
  computed: {
    route() {
      return this.$store.getters.getRoute;
    },
  },
};
</script>
<style lang="scss" scoped></style>
